import React, { useState, useEffect } from 'react';
import PrescriptionTable from '../Body/Prescriptiontable';
import NavigationMenu from '../Header/NavigationMenu';
import prescriptionService from '../services/prescriptionService';
// import NavigationClinicalMagnament from "../Navigation/NavigationClinicalMagnament";
import DoctorManagementMenu from "../../../components/common/Menu/DoctorManagement";
import TopHeader from "../../../components/common/Header/TopHeader";

const PrescriptionList = () => {
    const [prescriptions, setPrescriptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const handleDeletePrescriptions = async (prescriptionsToDelete) => {
        try {
            if (Array.isArray(prescriptionsToDelete)) {
                // Eliminar múltiples prescripciones
                for (const prescription of prescriptionsToDelete) {
                    await prescriptionService.deletePrescription(prescription._id);
                }
                // Actualizar el estado local después de eliminar todas
                const idsToDelete = prescriptionsToDelete.map(p => p._id);
                setPrescriptions(prev => prev.filter(p => !idsToDelete.includes(p._id)));
            } else {
                // Eliminar una sola prescripción
                await prescriptionService.deletePrescription(prescriptionsToDelete.id);
                // Actualizar el estado local
                setPrescriptions(prev => prev.filter(p => p._id !== prescriptionsToDelete.id));
            }
        } catch (error) {
            console.error('Error deleting prescription(s):', error);
            // Aquí podrías mostrar un mensaje de error al usuario
        }
    };

    // Fetch prescriptions from API when component mounts
    useEffect(() => {
        fetchPrescriptions();
    }, []);

    // function to fetch prescriptions from the API
    const fetchPrescriptions = async () => {
        try {
            setIsLoading(true);
            const response = await prescriptionService.getAllPrescriptions();
            
            if (response.status) {
                // Process prescriptions to handle potential null fields
                const processedPrescriptions = response.data.map(prescription => {
                    return {
                        ...prescription,
                        doctor: prescription.doctor || { _id: 'unknown' },
                        patient: prescription.patient || { _id: 'unknown' }
                    };
                });
                
                setPrescriptions(processedPrescriptions);
                setError(null);
            } else {
                setError('Error al obtener prescripciones: ' + (response.message || 'Error desconocido'));
            }
        } catch (error) {
            console.error('Error fetching prescriptions:', error);
            setError('Error al cargar las prescripciones. Por favor, inténtelo de nuevo más tarde.');
        } finally {
            setIsLoading(false);
        }
    };
        
    return (
        <main id="app">
            <TopHeader />
            <div className="content_wrapper">
            <div class="doctor-management-wrapper bg-white pb-5">
                {/* <NavigationClinicalMagnament/> */}
                <DoctorManagementMenu activeMenu='/prescriptions'/>
                {/* <NavigationMenu /> */}
                
                                              
                            <section>
                                <PrescriptionTable
                                    prescriptions={prescriptions}
                                    onDeletePrescriptions={handleDeletePrescriptions}
                                />
                            </section>
                       
                
            </div>
            </div>
        </main>
    );
};

export default PrescriptionList;